import PropTypes from "prop-types"
import styled from "@emotion/styled"

const HeroCaseInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const HeroCaseInfoTop = styled.div`
  display: flex;
  align-items: center;
`

const HeroCaseInfoText = styled.span`
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
`

const HeroCaseInfoWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  height: 46px;
`

const HeroScrollClutch = ({ text, rating }) => {
  const StarsWrapper = styled.div`
    display: inline-block;
    font-size: 22px;
    font-family: Times; // make sure ★ appears correctly
    line-height: 1;
    padding-left: 10px;

    &::before {
      content: "★★★★★";
      letter-spacing: 0px;
      background: linear-gradient(
        90deg,
        ${({ theme }) => theme.palette.primary.main} ${`${(rating / 5) * 100}%`},
        ${({ theme }) => theme.palette.gray[300]} ${`${(rating / 5) * 100}%`}
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  `

  return (
    <HeroCaseInfoWrapper>
      <HeroCaseInfoContainer>
        <HeroCaseInfoTop>
          <HeroCaseInfoText>{rating}</HeroCaseInfoText>
          <StarsWrapper rating={rating} />
        </HeroCaseInfoTop>
      </HeroCaseInfoContainer>
    </HeroCaseInfoWrapper>
  )
}

HeroScrollClutch.propTypes = {
  text: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired,
}

export default HeroScrollClutch
